import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ accountNumber: any }>;

export const DispatchSetAccountNumber: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReviewAndSubmit/SetAccountNumber",
        accountNumber: props.parameter.accountNumber,
    });
};

export const chain = [DispatchSetAccountNumber];

const setAccountNumber = createHandlerChainRunner(chain, "SetAccountNumber");
export default setAccountNumber;
